import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyCredentialsStore from '../../../../../stores/credentials/shipping/api-key-credentials-store';
import ApiSecretCredentialsStore from '../../../../../stores/credentials/shipping/api-secret-credentials-store';
import CustomerNumberCredentialsStore from '../../../../../stores/credentials/shipping/customer-number-credentials-store';
import IntersoftCredentialsStore from '../../../../../stores/credentials/shipping/intersoft-credentials-store';
import WebshipperCredentialsStore from '../../../../../stores/credentials/shipping/webshipper-credentials-store';
import MondialRelayCredentialsStore from '../../../../../stores/credentials/shipping/mondial-relay-credentials-store';
import ReboundCredentialsStore from '../../../../../stores/credentials/shipping/rebound-credentials-store';
import DhlCredentialsStore from "../../../../../stores/credentials/shipping/dhl-credentials-store";
import SendcloudReturnsCredentialsStore
    from '../../../../../stores/credentials/shipping/sendcloud-returns-credentials-store';
import FedexCredentialsStore from "../../../../../stores/credentials/shipping/fedex-credentials-store";
import ShipmonkCredentialsStore from "../../../../../stores/credentials/shipmonk-credentials-store";

interface IProps {
    credentialsStore: ApiKeyCredentialsStore |
    ApiSecretCredentialsStore |
    CustomerNumberCredentialsStore |
    IntersoftCredentialsStore |
    WebshipperCredentialsStore |
    MondialRelayCredentialsStore |
    ReboundCredentialsStore |
    DhlCredentialsStore |
    SendcloudReturnsCredentialsStore |
    FedexCredentialsStore |
    ShipmonkCredentialsStore,
    validationGroup: IValidationGroup,
    label?: string,
    note?: string,
    disabled?: boolean,
}

const ApiKeyField: React.FC<IProps> = observer(({ credentialsStore, validationGroup, label, note, disabled }) => {
    return (
        <FormFieldLine
            required
            label={label || 'Api Token'}
            key='api_key'
            note={note || 'Api token for this account'}
        >
            <Input
                value={credentialsStore.apiKey}
                onChange={credentialsStore.setApiKey}
                validationGroup={validationGroup}
                required
                autoComplete='new-password'
                type='password'
                disabled={disabled}
            />
        </FormFieldLine>
    )
});

export default ApiKeyField;
